module.exports = __webpack_public_path__ + "img/hasselt-2.a2e4a223.jpg";